import { IOption } from '@cian/ui-kit';
import { TSortType } from '../types/filters';

export const SORTING_OPTIONS: IOption<TSortType>[] = [
  {
    label: 'По умолчанию',
    value: 'default',
  },
  {
    label: 'По алфавиту',
    value: 'name',
  },
  {
    label: 'По количеству ЖК',
    value: 'newobjectCount',
  },
  {
    label: 'По количеству объявлений',
    value: 'offerCount',
  },
];
